import React from 'react';
import PropTypes from 'prop-types';

const MainLayout = ({
  title,
  children,
  showLogo,
  showDivider,
  footer,
  footerGrey,
  headerRight,
}) => (
  <section>
    <div style={{clear: 'both'}} />
    <div
      className={`page-header mhd--page-header clearfix ${
        showDivider ? '' : 'no-border'
      }`}
    >
      {showLogo && (
        <img
          alt="mHelpDesk"
          className="pull-right"
          src="/images/mhd-logo-600.jpeg"
          style={{float: 'right', width: 90, height: 45}}
        />
      )}
      <h1 key="header" style={{float: 'left'}}>
        {title}
      </h1>
      <div style={{float: 'right'}}>{headerRight}</div>
    </div>
    <main
      className={footerGrey ? 'mhd--page-with-footer' : ''}
      style={{margin: '0 15px'}}
    >
      {children}
    </main>
    <footer className={footerGrey ? 'mhd--page-footer-grey' : ''}>
      {footer}
    </footer>
  </section>
);

MainLayout.defaultProps = {
  footer: null,
  footerGrey: false,
  headerRight: null,
  showDivider: true,
  showLogo: false,
};

MainLayout.propTypes = {
  children: PropTypes.any.isRequired,
  footer: PropTypes.element,
  footerGrey: PropTypes.bool,
  headerRight: PropTypes.node,
  showDivider: PropTypes.bool,
  showLogo: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

export default MainLayout;



// WEBPACK FOOTER //
// ./src/components/Common/Structure/MainLayout.js